






























import { Component, Vue } from "vue-property-decorator";
import { WorkshopModel, CompanyModel } from "@/core/models";
import { WorkshopService } from "@/core/services";
import { WorkshopDetailHeaderCpt, WorkshopClientHeaderCpt, WorkshopClientRevGridCpt } from "./components";
import AppVue from "@/AppVue.vue";

@Component({
  components: {
    WorkshopDetailHeaderCpt,
    WorkshopClientHeaderCpt,
    WorkshopClientRevGridCpt,
  },
})
export default class RevisionsView extends AppVue {
  companyModel?: CompanyModel = new CompanyModel();
  model = {} as WorkshopModel;
  loading = false;

  get workshopId() {
    return Number(this.$route.params.workshopId);
  }
  get companyId() {
    return Number(this.$route.params.companyId);
  }

  async created() {
    this.initializeModel();
  }

  private async initializeModel() {
    this.loading = true;
    try {
      this.model = await WorkshopService.getWorkshop(this.workshopId);
      this.companyModel = this.model.companies.find(x => x.id === this.companyId);
    } finally {
      this.loading = false;
    }
  }
}
